import { useState, useEffect } from 'react';
import styles from './LimiterControl.module.css';
import Slider from '../Slider/Slider';

export default function LimiterControl({ sendCommand, limiterGain }) {
    const [sliderValue, setSliderValue] = useState(0);

    // Update slider when device state changes
    useEffect(() => {
        // Convert 0-30 dB to 0-1 for slider
        setSliderValue(limiterGain / 30.0);
    }, [limiterGain]);

    const handleGainChange = (value) => {
        setSliderValue(value);
        // Convert 0-1 slider to 0-30 dB
        const gainDb = value * 30.0;
        sendCommand('limiter.gain', gainDb.toFixed(1));
    };

    return (
        <div className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.header}>Master Limiter</h2>
                <div className={styles.controlsFrame}>
                    <Slider
                        label="Gain"
                        value={sliderValue}
                        onChange={handleGainChange}
                        displayValue={`${limiterGain.toFixed(1)} dB`}
                    />
                </div>
            </div>
        </div>
    );
}
